import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '@shared/buttons';

@Component({
  selector: 'la-upgrade-button',
  imports: [ButtonComponent],
  templateUrl: './upgrade-button.component.html',
  styleUrl: './upgrade-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeButtonComponent {
  @Input() disabled = false;
  @Input() buttonLink?: string[] = ['/account/subscription/upgrade'];
  @Input() text = 'Upgrade';

  @Output() action = new EventEmitter<void>();
}
